export default defineNuxtRouteMiddleware((to, from) => {
  const { setToken } = useAuthState()

  if (to.query.token) {
    setToken(to.query.token as string)
  }
})
